module.exports = __webpack_public_path__ + "static/Umar Azhar.4a5ca56d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Umar Azhar.jpg
// module id = 1243
// module chunks = 6166952557895